// P0 Pre-launch Pricing · FASE F/G nav+hub wire-up · Scale features extensions.
// -----------------------------------------------------------------------------
// Pattern additive (Caso A): entrambi i cluster `analytics` e `ai` già esistono
// in `_V12_USER_NAV_MINIMAL_RAW`. Qui applichiamo `groupPatches.append` ai due
// cluster + al cluster `automations` nav catalog full (quello esteso) per
// aggiungere i 2 nuovi item delle pagine P1/P2:
//
//   · Analytics Avanzata  →  /app/analytics/advanced  (requiredFeature: analytics_advanced)
//   · Automations Builder →  /app/automations/builder (requiredFeature: automations_builder)
//
// Entrambe le pagine sono route gated (<GatedRoute>) · gli item restano
// visibili a tutti gli user auth ma il routing redirige a PaywallUpsellCard
// se il piano è sotto il tier richiesto.
//
// Idempotente: se gli item sono già presenti nei cluster, no-op.

const _USER_ROLES = ["user", "admin", "super_admin"];

export const V12_USER_NAV_SCALE_FEATURES_EXTENSIONS = {
    groupPatches: {
        // Caso A · cluster "analytics" già presente nel MINIMAL.
        "analytics": {
            append: [
                {
                    id: "min-analytics-advanced",
                    label: "Analytics avanzata",
                    to: "/app/analytics/advanced",
                    implemented: true,
                    icon: "TrendingUp",
                    allowFor: _USER_ROLES,
                    requiredFeature: "analytics_advanced",
                    badge: "Scale",
                    keywords: ["analytics", "funnel", "cohort", "retention",
                               "advanced", "scale"],
                },
            ],
        },
        // Caso A · cluster "ai" già presente nel MINIMAL · ha già
        // "min-automations" che punta a /app/automations (hub). Aggiungiamo
        // il nuovo entry "Automations Builder" per /app/automations/builder.
        "ai": {
            append: [
                {
                    id: "min-automations-builder",
                    label: "Automations Builder",
                    to: "/app/automations/builder",
                    implemented: true,
                    icon: "Workflow",
                    allowFor: _USER_ROLES,
                    requiredFeature: "automations_builder",
                    badge: "Growth",
                    keywords: ["automation", "builder", "workflow", "trigger",
                               "action", "growth"],
                },
            ],
        },
    },
};


/**
 * Merge scale features · pure function · stesso contract di
 * applyUserDiscoveryExtensions / applyUserCommunityExtensions.
 *
 * Idempotente: se gli item esistono già nei cluster target → no-op per quel
 * cluster · altri cluster vengono comunque passati through.
 */
export function applyUserScaleFeaturesExtensions(baseGroups) {
    const patches = V12_USER_NAV_SCALE_FEATURES_EXTENSIONS.groupPatches;
    return baseGroups.map((g) => {
        const p = patches[g.id];
        if (!p || !p.append) return g;
        const existingIds = new Set((g.items || []).map((it) => it.id));
        const toAdd = p.append.filter((it) => !existingIds.has(it.id));
        if (toAdd.length === 0) return g;
        return { ...g, items: [...(g.items || []), ...toAdd] };
    });
}
